const reissuePossibleTypeList = {
  ONLY_IN_EXPIRATION: {code: 0, text: 'ダウンロード有効期限内のみ許可する'},
  ALWAYS: {code: 1, text: '常に許可する'},
}

export default {
  reissuePossibleTypeList,
}
